// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"977a5825","729":"8d51a027"}[chunkId] + ".chunk.js";
};